import { FC, useMemo } from "react";
import { CustomLabel, CustomLabelType } from "types/CustomLabel";
import { FormControl, MenuItem, Select, Stack, Typography } from "@mui/material";
import {
  formatSkillLevelLabel,
  getDefaultCustomLabels,
  stripLeadingSkillLevelScore,
} from "helpers/customLabels";

const SKILL_LEVEL_TYPES = new Set<string>([
  CustomLabelType.SKILL_LEVEL_SCORE_EPA,
  CustomLabelType.SKILL_LEVEL_SCORE_COMPETENCY,
]);

export type SelectCustomLabelProps = {
  customLabels: CustomLabel[];
  typeKey: CustomLabelType;
  value: number;
  onChange: (val: number) => void;
};

export const SelectCustomLabel: FC<SelectCustomLabelProps> = ({
  customLabels,
  typeKey,
  value,
  onChange,
}) => {
  const options = useMemo(() => {
    const scoped = customLabels.filter((c) => c.type === typeKey);
    if (scoped.length > 0) {
      return scoped
        .slice()
        .sort((a, b) => a.index - b.index)
        .map((c) => ({ label: c.label, value: c.index }));
    }
    return getDefaultCustomLabels(typeKey)
      .slice()
      .sort((a, b) => a.index - b.index)
      .map((c) => ({ label: c.label, value: c.index }));
  }, [customLabels, typeKey]);

  return (
    <FormControl fullWidth>
      <Select
        size="small"
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {SKILL_LEVEL_TYPES.has(typeKey) ? (
              <Stack direction="row" spacing={1.5} alignItems="center">
                <Typography component="span" fontWeight={700} sx={{ minWidth: 20 }}>
                  {opt.value}
                </Typography>
                <Typography component="span">
                  {stripLeadingSkillLevelScore(opt.label, opt.value) ||
                    formatSkillLevelLabel(opt.value, opt.label)}
                </Typography>
              </Stack>
            ) : (
              opt.label
            )}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
